export const SET_USER_DATA = 'src/store/auth/SET_USER_DATA';
export const IS_LOGGED_IN = 'src/store/auth/IS_LOGGED_IN';
export const SET_AUTH_USER = 'src/store/auth/SET_AUTH_USER';
export const SET_SHOW_PHONE_VERIFICATION_MODAL = 'src/store/auth/SET_SHOW_PHONE_VERIFICATION_MODAL';
export const SET_SHOW_EMAIL_VERIFICATION_MODAL = 'src/store/auth/SET_SHOW_EMAIL_VERIFICATION_MODAL';
export const SET_ERROR_LOGIN_DAC = 'src/store/auth/SET_ERROR_LOGIN_DAC';
export const SET_LOADING_LOGIN_DAC = 'src/store/auth/SET_LOADING_LOGIN_DAC';
export const SET_LOADING = 'src/store/auth/SET_LOADING';
